import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Profitmart: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h2>Profitmart API Setup in 8 Steps</h2>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <p>
            Visit the <b>Profitmart</b> page and complete the <b>login</b> process.
            <br />
            <b>
              <a href="https://profitmax.profitmart.in/#/" target="blank" title="profitmax Login">
                https://profitmax.profitmart.in/#/
              </a>
            </b>
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <p>
            Click the
            {oneIndentation}
            <b>Profile ID</b> section in the top-right corner.
          </p>
          <img src="/images/broker_setup_guide/profitmart/profitmart_step_1.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <p>
            Next, click the
            {oneIndentation}
            <b>API KEY</b> option.
          </p>
          <img src="/images/broker_setup_guide/profitmart/profitmart_step_2.png" alt="Create New App" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <p>
            Complete the required details below by filling in the <b>URL</b> and <b>Primary IP Address</b>{' '}
            boxes.
          </p>

          <img src="/images/broker_setup_guide/profitmart/profitmart_step_3.png" alt="Quantman App details" />

          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>URL:</h6>
              <span>https://www.quantman.trade/auth/profitmart/callback?client_id=xxxxxxx</span>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input
                    type="text"
                    placeholder="https://www.quantman.trade/auth/profitmart/callback?client_id=xxxxxxx"
                    disabled
                  />
                </span>
                <CopyTextButton text="https://www.quantman.trade/auth/profitmart/callback?client_id=xxxxxxx" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Primary IP Address</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Contact Support Team" disabled />
                </span>
                <CopyTextButton text="123.456.789" />
              </div>
            </div>
          </div>
        </div>
      </li>

      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <p>
            Then,
            {oneIndentation}
            click <b>Update</b> to save the changes.
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <p>
            Now, copy the <b>Secrect Code</b> and come back to the <b>QuantMan</b> website.
          </p>
          <img
            src="/images/broker_setup_guide/profitmart/profitmart_step_4.png"
            alt="Copy and paste api details"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="7">
        <div className="stepper_content">
          <p>
            Click the back button, type the <b>Client ID</b> and paste the <b>Secret Code</b> that you copied.
          </p>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Upstox fill form" />
        </div>
      </li>
      <li className="stepper_item" data-stepper="8">
        <div className="stepper_content">
          <p>
            Finally, press the <b>Login</b> button.
          </p>
        </div>
      </li>
    </div>
  </div>
);

export default Profitmart;
